// Der runde Knopf unten links oeffnet die Cookie-Einstellungen wieder.
// Vorher stand der Aufruf als onclick im Template.
//
// Hinweis: In dieser Datei lag bisher das Kauf-Tracking des Meta-Pixels -
// es steht jetzt in fn_tracking.js.

document.querySelectorAll('.ce_rsce_cookieOpen [data-fn-cookie-oeffnen]').forEach((knopf) => {
    knopf.addEventListener('click', () => {
        if (window.cookiebar && typeof window.cookiebar.show === 'function') {
            window.cookiebar.show();
        }
    });
});
